<template>
  <div>
    <custom-dialog class="contract_contract_print_dialog" width="1000px" appendToBody :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body" ref="print">
        <p class="date">{{ now }}</p>
        <div class="title-box">
          <h3>{{ $t('crm_contractConfirmDownload.zu_lin_que_ren_dan') }}</h3>
        </div>
        <table border="1" style="border-collapse: collapse; border: none" class="table">
          <!--  -->
          <tr v-if="model.type === 'trial'">
            <th class="key w15">{{ $t('crm_contractConfirmDownload.ding_dan_bian_hao') }}</th>
            <th class="val w35">{{ data.orderCode || '-' }}</th>
            <th class="val w15">{{ $t('crm_contractConfirmDownload.qian_ding_ri_qi') }}</th>
            <th class="val w35">{{ $momentLocal(data.signingDate, 'YYYY-MM-DD') || '-' }}</th>
          </tr>
          <tr v-else>
            <th class="key w15">{{ $t('crm_contractConfirmDownload.he_tong_bian_hao') }}</th>
            <th class="val w35">{{ data.contractNo || '-' }}</th>
            <th class="val w15">{{ $t('crm_contractConfirmDownload.sghth') }}</th>
            <th class="val w35">{{ data.customContractNo || '-' }}</th>
          </tr>
          <tr>
            <th class="key w15">{{ $t('crm_contractConfirmDownload.jfsqdb') }}</th>
            <th colspan="3" class="val">{{ data.partyAName || '-' }}</th>
          </tr>
          <tr>
            <th class="key w15">{{ $t('crm_contractConfirmDownload.zu_lin_fang') }}</th>
            <th colspan="3" class="val">{{ data.customerName || '-' }}</th>
          </tr>
          <tr>
            <th class="key w15">{{ $t('crm_contractConfirmDownload.lian_xi_ren') }}</th>
            <th class="val w35">{{ data.cdeliverAddress && data.cdeliverAddress.consigneeName }} {{ (data.cdeliverAddress && data.cdeliverAddress.consigneePhone) || '-' }}</th>
            <th class="val w15">{{ $t('crm_contractConfirmDownload.qi_zu_ri_qi') }}</th>
            <th class="val w35">{{ $momentLocal(model.rentalStartTime, 'YYYY-MM-DD') || '-' }}</th>
          </tr>
          <tr>
            <th class="key w15">{{ $t('crm_contractConfirmDownload.shi_yong_di_zhi') }}</th>
            <th class="val" colspan="3">
              {{ data.cdeliverAddress && `${data.cdeliverAddress.country}${data.cdeliverAddress.province}${data.cdeliverAddress.city}${data.cdeliverAddress.detailAddress}` }}
            </th>
          </tr>
          <tr>
            <th class="key w15">{{ $t('crm_contractConfirmDownload.shou_hou_gong_si') }}</th>
            <th colspan="3" class="val">{{ data.afterServiceName || '-' }}</th>
          </tr>
        </table>
        <table border="1" style="border-collapse: collapse; border: none; margin-top: -1px" class="table">
          <template v-for="(item, index) in deviceList">
            <tr :key="index">
              <th class="key wauto">{{ $t('crm_contractConfirmDownload.chan_pin_xing_hao') }}</th>
              <th class="val wauto">{{ item.productCode || '-' }}</th>
              <th class="key wauto">{{ $t('crm_contractConfirmDownload.she_bei_shu_liang') }}</th>
              <th class="val wauto">{{ item.deviceNumber || '-' }}</th>
              <th class="key wauto">{{ $t('crm_contractConfirmDownload.zu_lin_shi_chang') }}</th>
              <th class="val wauto">{{ item.rentalTerm || '-' }}{{ getDicValue('rental_term_unit', item.rentalTermUnit) }}</th>
            </tr>
            <tr :key="index">
              <th class="key">{{ $t('crm_contractConfirmDownload.ji_shen_hao') }}</th>
              <th colspan="5" class="val">{{ item.bodyNumList.toString() || '-' }}</th>
            </tr>
          </template>
        </table>
        <table border="1" style="border-collapse: collapse; border: none; margin-top: -1px" class="table" v-if="billPaymentList.length">
          <tr v-for="(item, index) in billPaymentList" :key="index">
            <th class="key wauto" :rowspan="billPaymentList.length + 1" v-if="index === 0">{{ $t('crm_contractConfirmDownload.ying_fu_kuan_ming_xi') }}</th>
            <th class="val wauto">{{ $momentLocal(item.billPaymentTime, 'YYYY-MM-DD') || '-' }}</th>
            <th class="key wauto">{{ getDicValue('bill_trade_state', item.billTradeState) }}</th>
            <!-- <th class="val wauto">{{ getDicValue('bill_type', item.billType) }}</th> -->
            <th class="key wauto">{{ $t('crm_contractConfirmDownload.ying_fu_jin_e') }}</th>
            <th class="val wautot">{{ item.paymentAmount || '-' }}</th>
          </tr>
        </table>
        <div class="base-msg">
          <el-row>
            <el-col :span="12" class="consignee">
              <el-col :span="24">
                <div class="key l-key">{{ $t('crm_contractConfirmDownload.jiao_huo_ren') }}</div>
                <div class="val"></div>
              </el-col>
              <el-col :span="24">
                <div class="key l-key">{{ $t('crm_contractConfirmDownload.lian_xi_fang_shi') }}</div>
                <div class="val"></div>
              </el-col>
              <el-col :span="24">
                <div class="key l-key">{{ $t('crm_contractConfirmDownload.jiao_huo_ri_qi') }}</div>
                <div class="val"></div>
              </el-col>
            </el-col>
            <el-col :span="12" class="consignee">
              <el-col :span="24">
                <div class="key l-key">
                  {{ $t('crm_contractConfirmDownload.shou_huo_ren') }}
                </div>
                <div class="val"></div>
              </el-col>
              <el-col :span="24">
                <div class="key l-key">{{ $t('crm_contractConfirmDownload.lian_xi_fang_shi') }}</div>
                <div class="val"></div>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
/**
 *
 */
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
// import QrcodeVue from 'qrcode.vue';
import moment from 'moment';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
    // QrcodeVue,
  },
  data() {
    return {
      data: {},
      isLoading: false,
      deviceList: [],
      billPaymentList: [],
    };
  },
  computed: {
    now() {
      return moment().format('YYYY-MM-DD');
    },
  },
  methods: {
    getPageInfo() {
      this.$getJSON(apis.contractInfo, {
        bizId: this.model.bizId,
        bizClass: this.model.bizClass,
      }).then((res) => {
        this.data = res.data;
        setTimeout(() => {
          this.$print(this.$refs.print);
        }, 1000);
      });
    },
    getDeviceList: function () {
      this.isLoading = true;
      // 已启租
      const bizState = this.model.row.find(i => `${i.bizState}` === '22');
      this.$getJSON(apis.ContractBillOrderListForOrderDevice, {
        orderId: this.model.bizId,
        bodyNumList: this.model.row.map(i => i.bodyNum).toString(),
        dataType: bizState ? 2 : 1,
        rentDate: bizState ? null : this.$momentLocal(this.model.rentalStartTime, 'YYYY-MM-DD'), // 因为选出来的是世界时间  加上不传时间传日期要传本地的时间与实际选择的日期相对应
      }).then((res) => {
        this.isLoading = false;
        const data = res.data || [];
        this.billPaymentList = data;
      });
    },
    computedDevice() {
      const deviceType = [];
      this.model.row.forEach((item) => {
        const mergeItem = deviceType.find(f => item.productCode === f.productCode && item.rentalTerm === f.rentalTerm && item.rentalTermUnit === f.rentalTermUnit);
        if (!mergeItem) {
          deviceType.push({
            productCode: item.productCode,
            rentalTerm: item.rentalTerm,
            rentalTermUnit: item.rentalTermUnit,
            deviceNumber: 1,
            bodyNumList: [item.bodyNum],
          });
        } else {
          mergeItem.deviceNumber += 1;
          mergeItem.bodyNumList.push(item.bodyNum);
        }
      });
      this.deviceList = deviceType;
      // console.log(deviceType);
    },
    // 保存新增
    computedPay: function (ele) {
      const periods = this.getPeriods(ele); // 付款期数
      const paymentPeriod = Number.parseInt(ele.paymentPeriod, 10); // 付款周期，0为全款
      const list = this.setPeriodsDate(periods, paymentPeriod, ele);
      // this.$set(ele, 'children', list);
      // ele=(list
      // return ele
      this.deviceList.push(...list);
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
  mounted() {
    this.getPageInfo();
    this.getDeviceList();
    this.computedDevice();
  },
};
</script>

<style lang="scss">
.contract_contract_print_dialog {
  padding: 16px;
  .date {
    font-size: 14px;
    line-height: 20px;
    color: #000;
  }
  .title-box {
    text-align: center;
    // display: flex;
    // align-items:center ;
    position: relative;
    margin-bottom: 30px;
    h3 {
      padding: 0 12px;
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      color: #000;
      line-height: 40px;
    }
    .qr-code-content {
      position: absolute;
      right: 0;
      top: 0;
      // width:38px;
    }
  }

  table {
    width: 100%;

    th {
      font-size: 12px;
      color: #000;
      font-weight: normal !important;
      text-align: left;
      padding: 0 5px;
      line-height: 30px;
      border: 1px solid #000;
      // width: calc(100% /6);
    }
    // .key{
    //   width: 16%;
    // }
    // .val{
    //   width:28%;
    // }
    .wauto {
      width: calc(100% / 6);
    }
    .wautot {
      width: calc(100% / 6 * 2);
    }
    .w15 {
      width: calc(100% / 6);
    }
    .w35 {
      width: calc(50% - (100% / 6));
    }
  }
  .base-msg {
    color: #000;
    font-size: 14px;
    line-height: 17px;
    margin: 60px 0 20px;

    .key,
    .val {
      float: left;
      height: 32px;
      font-size: 14px;
      color: #000;
      line-height: 32px;
    }

    .key {
      padding-left: 16px;
    }
    // .s-key {
    //   width: 80px;
    // }
    // .l-key {
    //   width: 180px;
    // }

    .consignee {
      margin-top: 5px;
    }
  }
}
@media print {
  *noprint::after {
    content: '' !important;
  }
  // 去掉页眉 页尾
  .header,
  .footer {
    display: none;
  }
  @page {
    // size: auto; /* auto is the initial value */
    // margin: 3mm; /* this affects the margin in the printer settings */
    size: A4 portrait;
    margin: 1.5cm 0.5cm 0mm;
    font-family: 'SimSun', '宋体' !important;
  }

  html {
    background-color: #ffffff;
    margin: 0px; /* this affects the margin on the html before sending to printer */
    font-family: 'SimSun', '宋体' !important;
  }

  body {
    // border: solid 1px blue ;
    margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
    font-family: 'SimSun', '宋体' !important;
  }
  .date {
    font-size: 14px;
    line-height: 20px;
    color: #000;
  }
  .title-box {
    text-align: center;
    // display: flex;
    // align-items:center ;
    position: relative;
    margin-bottom: 30px;

    h3 {
      padding: 0 12px;
      text-align: center;
      font-size: 22px;
      color: #000;
      line-height: 40px;
      font-weight: normal !important;
      // font-weight: bold !important;
    }
    .qr-code-content {
      position: absolute;
      right: 0;
      top: 0;
      // width:38px;
    }
  }

  table {
    width: 100%;
    // border: 1px solid #000;
    th {
      font-size: 12px;
      color: #000;
      font-weight: normal !important;
      text-align: left;
      padding: 0 5px;
      line-height: 30px;
      border: 1px solid #000;
      // font-weight: bold !important;
      // width: calc(100% /6);
    }
    .wauto {
      width: calc(100% / 6);
    }
    .wautot {
      width: calc(100% / 6 * 2);
    }
    .w15 {
      width: calc(100% / 6);
    }
    .w35 {
      width: calc(50% - (100% / 6));
    }
  }
  .base-msg {
    color: #000;
    font-size: 14px;
    line-height: 17px;
    margin: 60px 0 20px;

    .key,
    .val {
      float: left;
      height: 32px;
      font-size: 14px;
      color: #000;
      line-height: 32px;
    }

    .key {
      padding-left: 16px;
    }
    // .s-key {
    //   width: 80px;
    // }
    // .l-key {
    //   width: 180px;
    // }

    .consignee {
      margin-top: 5px;
    }
  }
}
</style>
